"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.v2 = void 0;

var _fonts = _interopRequireDefault(require("../fonts"));

var _colors = require("../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var family = _fonts["default"].family,
    weight = _fonts["default"].weight,
    letterSpacing = _fonts["default"].letterSpacing;
var label = {
  label1: {
    fontFamily: family.regular,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    textTransform: 'capitalize',
    lineHeight: '17px',
    color: _colors.baseColors_v2.atomic
  },
  placeholder1: {
    fontFamily: family.regular,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    textTransform: 'capitalize',
    lineHeight: '17px',
    color: _colors.baseColors.ashGrey
  },
  error: {
    fontFamily: family.regular,
    fontSize: '12px',
    letterSpacing: letterSpacing["default"],
    textTransform: 'capitalize',
    lineHeight: '17px',
    color: _colors.baseColors.mordantRed
  },
  assistive: {
    fontFamily: family.regular,
    fontSize: '12px',
    letterSpacing: letterSpacing["default"],
    textTransform: 'capitalize',
    lineHeight: '17px',
    color: _colors.baseColors_v2.atomic
  },
  notification: {
    fontFamily: family.semiBold,
    fontSize: '12px',
    letterSpacing: letterSpacing["default"],
    textTransform: 'capitalize',
    lineHeight: '17px',
    color: _colors.baseColors.white
  }
};
var action = {
  primary: {
    fontFamily: family.semiBold,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '17px',
    color: _colors.baseColors.white
  },
  secondary: {
    fontFamily: family.semiBold,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '17px',
    color: _colors.baseColors_v2.black
  },
  tertiary: {
    fontFamily: family.semiBold,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '17px',
    color: _colors.baseColors.denim
  },
  disabled: {
    fontFamily: family.text,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '17px',
    color: _colors.baseColors.white,
    secondary: {
      color: _colors.baseColors.ashGrey
    },
    tertiary: {
      color: _colors.baseColors.ashGrey
    },
    link: {
      color: _colors.baseColors.ashGrey
    }
  },
  link: {
    fontFamily: family.medium,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '17px',
    color: _colors.baseColors_v2.black
  }
};
var content = {
  "default": {
    fontFamily: family.regular,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '17px',
    color: _colors.baseColors_v2.black
  },
  default1Highlight: {
    fontFamily: family.medium,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '17px',
    color: _colors.baseColors_v2.black
  },
  content1: {
    fontFamily: family.regular,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '17px',
    color: _colors.baseColors_v2.black
  },
  content1Highlight: {
    fontFamily: family.medium,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '17px',
    color: _colors.baseColors_v2.black
  }
};
var heading = {
  heading1: {
    fontFamily: family.semiBold,
    fontSize: '24px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '29px',
    color: _colors.baseColors_v2.black
  },
  heading1Regular: {
    fontFamily: family.regular,
    fontSize: '24px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '29px',
    color: _colors.baseColors_v2.black
  },
  heading2: {
    fontFamily: family.semiBold,
    fontSize: '21px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '25px',
    color: _colors.baseColors_v2.black
  },
  heading2Regular: {
    fontFamily: family.regular,
    fontSize: '21px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '25px',
    color: _colors.baseColors_v2.black
  },
  heading3: {
    fontFamily: family.semiBold,
    fontSize: '18px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '23px',
    color: _colors.baseColors_v2.black
  },
  heading3Regular: {
    fontFamily: family.regular,
    fontSize: '18px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '19px',
    color: _colors.baseColors_v2.black
  },
  heading4: {
    fontFamily: family.semiBold,
    fontSize: '16px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '19px',
    color: _colors.baseColors_v2.black
  },
  heading4Regular: {
    fontFamily: family.regular,
    fontSize: '16px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '19px',
    color: _colors.baseColors_v2.black
  },
  heading5: {
    fontFamily: family.semiBold,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '19px',
    color: _colors.baseColors_v2.black
  },
  heading5Regular: {
    fontFamily: family.regular,
    fontSize: '14px',
    letterSpacing: letterSpacing["default"],
    lineHeight: '19px',
    color: _colors.baseColors_v2.black
  }
};
var v2 = {
  label: label,
  content: content,
  heading: heading,
  action: action
};
exports.v2 = v2;